import Link from 'next/link';
import type React from 'react';
import { cn } from '../../features/shared/utils/cn';

type MenuItemProps = {
	title: string;
	role?: string;
	className?: string;
	href: string;
	onClick?: () => void;
};

export const NavigationDropDownItem = ({
	title,
	href,
	role,
	className,
	onClick,
}: MenuItemProps) => (
	// Legacy behavior due to old next version. Cannot style next/link otherwise
	<Link href={href} legacyBehavior>
		<a
			onClick={onClick}
			className={cn(
				'px-[16px] pb-[16px] pt-[15px] rounded-[4px]',
				'text-black text-[18px] leading-[21.6px] !underline',
				'hover:bg-primary-default hover:text-white',
				'focus-visible:bg-primary-default focus-visible:text-white focus-visible:[outline:2px_solid_#430042]',
				className,
			)}
			role={role}
			href={href}
		>
			<span className="text-[18px] leading-[21.6px] font-normal">{title}</span>
		</a>
	</Link>
);
